import React, { useEffect, useState } from 'react';
import html2pdf from 'html2pdf.js';
import { generateHtml } from './html';
import {
  inputValueString,
  inputValueNumber,
  UfMunicipio,
  Filters,
  Data,
  Campaign,
} from 'services/producer-consultation/types';
import Input from 'components/ProducerManagement/input';
import InfoProducer from 'components/Auth/Modals/InfoProducer';
import getDataProducer from 'services/producer-consultation/getProducerData';
import getValuesSelectProducerA from 'services/producer-consultation/getValuesSelectProducerA';
import getValuesSelectProducerB from 'services/producer-consultation/getValuesSelectProducerB';
import getProdutorInfo from 'services/producer-consultation/getProdutorInfo';
import getCampaigns from 'services/cockpit/getCampaign';
import ProducerCarousel from 'components/ProducerCarousel';
import { AiFillInfoCircle } from 'react-icons/ai';
import {
  Banner,
  Container,
  Wrapper,
  FiltersBox,
  BoxRadio,
  ProducerBox,
} from './styles';
import { formatarMoedaBRL } from './mask';

const ProducerConsultation: React.FC = () => {
  // State declarations
  const [channels, setChannels] = useState<inputValueString[]>([]);
  const [regional, setRegional] = useState<inputValueString[]>([]);
  const [ufAndMunicipio, setUfAndMunicipio] = useState<UfMunicipio[]>([]);
  const [uf, setUf] = useState<inputValueString[]>([]);
  const [municipio, setMunicipio] = useState<inputValueNumber[]>([]);
  const [producer, setProducer] = useState<inputValueString[]>([]);
  const [getFilters, setGetFilters] = useState<Filters>({});
  const [filters, setFilters] = useState<Filters>({});
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);

  const [getValuesSelect, setValuesSelect] = useState<any>(0);
  const [boxA, setBoxA] = useState<Data[]>([]);
  const [filterSafraA, setFilterSafraA] = useState<number | undefined>();
  const [initialSafraA, setInitialSafraA] = useState<number>(0);
  const [boxB, setBoxB] = useState<Data[]>([]);
  const [filterSafraB, setFilterSafraB] = useState<number | undefined>();
  const [initialSafraB, setInitialSafraB] = useState<number>();
  const [open, setOpen] = useState<boolean>(false);
  const [producerInfo, setProducerInfo] = useState<any>([]);
  const [title, setTitle] = useState<string>('');

  const [modalOpened, setModalOpened] = useState(false);

  const handleDownload = () => {
    const htmlContent = generateHtml({
      producerInfo,
      title,
      boxA,
      boxB,
    });

    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlContent;
    document.body.appendChild(tempContainer);

    html2pdf()
      .from(tempContainer)
      .set({
        margin: 0,
        filename: `${producerInfo.name}-${title}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a3', orientation: 'landscape' }, // <-- aqui
      })
      .save()
      .then(() => {
        document.body.removeChild(tempContainer);
      });
  };

  useEffect(() => {
    const fetchCampaign = async () => {
      const data = await getCampaigns();

      const dataFilter = data.filter(item => {
        return item.isTerraBrasil === false;
      });

      setCampaigns(dataFilter); // Assuming you want to set the filtered campaign
    };
    fetchCampaign();
  }, []);

  // Fetch producer data based on filters
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getDataProducer(filters);
        setChannels(data.channels || []);
        setRegional(data.regional || []);
        setUfAndMunicipio(data.ufAnMunicipio || []);
        setProducer(data.produtor || []);
      } catch (error) {
        console.error('Error fetching producer data:', error);
      }
    };
    fetchData();
  }, [filters]);

  // Fetch values for select inputs
  useEffect(() => {
    const fetchValuesSelect = async () => {
      if (getValuesSelect > 0) {
        try {
          const values = await getValuesSelectProducerA(
            getValuesSelect,
            filterSafraA,
            filters,
          );
          setBoxA(values);
          values.length > 0 && setOpen(true);
          if (filterSafraA === undefined) {
            setInitialSafraA(values[0].camapanha_id);
          }
        } catch (error) {
          console.error('Error fetching values select:', error);
        }
      }
    };
    fetchValuesSelect();
  }, [getValuesSelect, filterSafraA, filters]);

  // Fetch values for select inputs
  useEffect(() => {
    const fetchValuesSelect = async () => {
      if (getValuesSelect > 0) {
        try {
          const values = await getValuesSelectProducerB(
            getValuesSelect,
            filterSafraB,
            filters,
          );
          setBoxB(values);
          if (filterSafraB === undefined) {
            setInitialSafraB(values[0].camapanha_id);
          }
        } catch (error) {
          console.error('Error fetching values select:', error);
        }
      }
    };
    fetchValuesSelect();
  }, [getValuesSelect, filterSafraB, filters]);

  useEffect(() => {
    const fetGetValuesSelect = async () => {
      if (fetGetValuesSelect.length === 0) {
        try {
          const values = await getProdutorInfo(getValuesSelect);
          setProducerInfo(values);
        } catch (error) {
          console.error('Error fetching values select:', error);
        }
      }
    };
    fetGetValuesSelect();
  }, [getValuesSelect]);

  useEffect(() => {
    const uniqueUFsteste = Array.from(
      new Set(
        ufAndMunicipio.map(item =>
          JSON.stringify({ label: item.uf, value: item.uf }),
        ),
      ),
    ).map(str => JSON.parse(str));

    setUf(uniqueUFsteste);
    const uniqueMunicipios = Array.from(
      new Set(ufAndMunicipio.map(item => item.municipio.trim())),
    )
      .sort() 
      .map(municipio => ({ label: municipio, value: municipio }));

    setMunicipio(uniqueMunicipios);
  }, [ufAndMunicipio]);

  useEffect(() => {
    const filterData = () => {
      const filters = {
        canal: getFilters.canal || '',
        regional: getFilters.regional || '',
        uf: getFilters.uf || '',
        municipio: getFilters.municipio || '',
        farmersWithInvoicesCurrentSeason:
          getFilters.farmersWithInvoicesCurrentSeason || '',
      };
      setFilters(filters);
    };
    filterData();
  }, [getFilters]);

  // Options for radio buttons
  const optionsRadios = ['Sim', 'Não'];

  const handleCanal = (
    value: { value: string | number; label: string } | null,
  ) => {
    setGetFilters({ ...getFilters, canal: value?.value });
    if(value?.label){
      setTitle(value?.label); 
    }else{
      setTitle('');
    }
  };

  const handleRegional = (
    value: { value: string | number; label: string } | null,
  ) => {
    setGetFilters({ ...getFilters, regional: value?.value });
  };

  const handleUF = (
    value: { value: string | number; label: string } | null,
  ) => {
    setGetFilters({ ...getFilters, uf: value?.value });
  };

  const handleMunicipio = (
    value: { value: string | number; label: string } | null,
  ) => {
    setGetFilters({ ...getFilters, municipio: value?.value });
  };

  const handleProducer = (
    value: { value: string | number; label: string } | null,
  ) => {
    if (filterSafraA !== null) {setFilterSafraA(undefined);}
    if (filterSafraB !== null) {setFilterSafraB(undefined);}
    if (value === null) {setOpen(false);}
    setValuesSelect(value?.value);
  };

  return (
    <Container>
      <Banner>
        <Wrapper>
          <h1>Gestão de Produtores</h1>
          <p>
            Acesse dados detalhados das compras dos produtores e compare safras
            para otimizar sua análise e planejamento.
          </p>

          <FiltersBox>
            {/* Canal Filter */}
            <div className="filter">
              <Input
                options={channels || []}
                Title={'Canal'}
                placeholder={'Selecione um canal'}
                onChange={handleCanal}
              />
            </div>

            {/* Regional Filter */}
            <div className="filter">
              <Input
                options={regional || []}
                Title={'Regional'}
                placeholder={'Selecione uma regional'}
                onChange={handleRegional}
              />
            </div>

            {/* UF and Municipio Filters */}
            <div className="filter">
              <Input
                options={uf || []}
                Title={'UF'}
                placeholder={'Selecione uma UF'}
                onChange={handleUF}
              />
              <br />
              <Input
                options={municipio || []}
                Title={'Município'}
                placeholder={'Selecione um município'}
                onChange={handleMunicipio}
              />
            </div>

            {/* Radio Buttons */}
            <div className="filter">
              <strong>Produtores com NFs na safra vigente?</strong>
              <div>
                {optionsRadios.map((option, index) => (
                  <BoxRadio key={index}>
                    <label
                      className="radio-personalizado"
                      htmlFor={`radio-${index}`}
                    >
                      <input
                        type="radio"
                        id={`radio-${index}`}
                        name="radio-group"
                        value={option}
                        checked={
                          getFilters.farmersWithInvoicesCurrentSeason === option
                        }
                        onChange={e =>
                          setGetFilters({
                            ...getFilters,
                            farmersWithInvoicesCurrentSeason: e.target.value,
                          })
                        }
                      />
                      <span className="custom-radio" />
                      {option}
                    </label>
                  </BoxRadio>
                ))}
              </div>
            </div>
          </FiltersBox>
        </Wrapper>
      </Banner>

      <Wrapper>
        <ProducerBox>
          {/* Producer Selection */}
          <div className="header">
            <Input
              options={producer || []}
              Title={'Produtores'}
              placeholder={'Selecione um produtor'}
              onChange={handleProducer}
            />
          </div>

          {/* Table Data */}
          {open && (
            <>
              <div className="body">
                <div className="table">
                  {/* Row 1 */}
                  <div className="row-1">
                    <strong>{producerInfo.name}</strong>
                    <h3>{title}</h3>

                    <div className="tooltip">
                      <button
                        className="tooltip-button"
                        onClick={() => setModalOpened(true)}
                      >
                        <AiFillInfoCircle />
                      </button>
                      <span className="tooltip-text">
                        Informações do Produtor
                      </span>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="row-2">
                    <table>
                      <thead>
                        <tr>
                          <th colSpan={4}>
                            <ProducerCarousel
                              options={campaigns}
                              initialCampaignId={initialSafraA}
                              onCampaignIdChange={(id: number) => {
                                setFilterSafraA(id);
                              }}
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="fill-in-title">Data da NF</td>
                          <td className="fill-in-title">Produto</td>
                          <td className="fill-in-title">Volume total(KG/L)</td>
                          <td className="fill-in-title">Valor total(R$)</td>
                        </tr>
                        {boxA.map((item, index) => (
                          <tr key={index}>
                            <td>{item.invoice_date}</td>
                            <td>{item.product_name}</td>
                            <td>{formatarMoedaBRL(item.volume_kg_lt)}</td>
                            <td>{formatarMoedaBRL(item.total_value)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Row 3 */}
                  <div className="row-3">
                    <table>
                      <thead>
                        <tr>
                          <th colSpan={4}>
                            <ProducerCarousel
                              options={campaigns}
                              initialCampaignId={initialSafraB}
                              onCampaignIdChange={(id: number) => {
                                setFilterSafraB(id);
                              }}
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="fill-in-title">Data da NF</td>
                          <td className="fill-in-title">Produto</td>
                          <td className="fill-in-title">Volume total(KG/L)</td>
                          <td className="fill-in-title">Valor total(R$)</td>
                        </tr>
                        {boxB.map((item, index) => (
                          <tr key={index}>
                            <td>{item.invoice_date}</td>
                            <td>{item.product_name}</td>
                            <td>{formatarMoedaBRL(item.volume_kg_lt)}</td>
                            <td>{formatarMoedaBRL(item.total_value)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="body-btn-download">
                <button onClick={handleDownload}>BAIXAR COMPARATIVO</button>
              </div>

              <InfoProducer
                isOpen={modalOpened}
                onRequestClose={() => setModalOpened(false)}
                producerInfo={producerInfo}
              />
            </>
          )}
        </ProducerBox>
      </Wrapper>
    </Container>
  );
};

export default ProducerConsultation;
